export default {
    computed: {
        validType() {
            return ['mcd', 'masterclass', 'summit', 'live-course'].indexOf(this.eventType) > -1;
        },

        validDocument() {
            return ['invoice', 'certificate'].indexOf(this.eventDocument) > -1;
        },

        eventType() {
            return this.$route.params.type;
        },

        eventDocument() {
            return this.$route.params.document;
        },

        eventName() {
            return {
                mcd: 'Masterclass Day',
                masterclass: 'Masterclass',
                summit: 'Super Summit',
                'live-course': 'Live Course'
            }[this.eventType];
        },

        documentData() {
            const type = this.eventType === 'live-course' ? 'course' : 'event'

            return {
                invoice: {
                    heading: 'Retrieve Your Tax Invoice',
                    helperText: `To generate your payment tax invoice, please select the relevant ${type} from the list below; enter your email address (this must be the same email you used to register); and click “Get Tax Invoice”.`,
                    component: 'gh-form-invoice'
                },
                certificate: {
                    heading: 'Generate Your Certificate of Attendance',
                    helperText: `To generate your attendance certificate, please select the relevant ${type} from the list below; enter your email address (this must be the same email you used to register); and click “Get Certificate”.`,
                    component: 'gh-form-certificate'
                }
            }[this.eventDocument];
        }
    }
}